import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Header } from 'components/header/header';
import { Logout } from 'components/Logout/Logout';
import { useRecordPageLogoutView } from './hooks/useRecordPageLogoutView';
import { setPageName } from 'actions/errorViewNavigation';

const LogoutViewComponent = ({ products, userProfile, setPageName }) => {
    useRecordPageLogoutView({ userProfile, products, setPageName });

    return (
        <>
            <Header titleClass="hidden" />
            <div className="main-container messages-main-container basic-layering prospects-content">
                <Logout />
            </div>
        </>
    );
};

const mapStateToProps = state => ({
    userProfile: state.userProfile,
    products: state.products,
});

const mapDispatchToProps = dispatch => ({
    setPageName: bindActionCreators(setPageName, dispatch),
});

export const LogoutView = connect(mapStateToProps, mapDispatchToProps)(LogoutViewComponent);
